import React, { Component } from 'react';
import './style.css';
import { HeaderQuestion, NextQuestionButton } from '../../components';
import { Trans, translate } from 'react-i18next';

class Opposite extends Component {
  constructor(props) {
    super(props);
    let opposite = props.pair.answer.opposite || '';
    this.state = {
      value: opposite
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  render() {
    const term = this.props.term;
    const maxLength = this.props.maxLength;
    const description = (
      <Trans i18nKey="opposite">
        What is the opposite of "{{ term }}
        "?
      </Trans>
    );
    return (
      <div className="card-body">
        <form onSubmit={this.handleSubmit}>
          <HeaderQuestion
            text=""
            description={description}
            skip={this.props.skip}
            pairId={this.props.pair.pairId}
          />
          <div className="App-answer-instructions">
            <Trans i18nKey="maxLetters">
              Please enter only 1 characteristic using max. {{ maxLength }}{' '}
              letters:
            </Trans>
          </div>
          <div className="input-group App-answer-text App-answer">
            <input
              autoFocus
              type="text"
              className="form-control"
              onChange={this.handleChange}
              value={this.state.value}
              maxLength={this.props.maxLength}
            />
          </div>
          <NextQuestionButton
            to={this.props.url}
            onClick={() => this.props.save(this.state.value)}
            disabled={this.state.value ? false : true}
          />
        </form>
      </div>
    );
  }
}

export default translate('translations')(Opposite);



// WEBPACK FOOTER //
// ./src/comparison/components/Pair/opposite.js